import groq from 'groq'

import { metadata } from '../../projections/metadata.js'
import { footer } from '../../projections/footer.js'
import { faqItems } from '../../projections/faqItems.js'
import { header } from './sections/header.js'

export function faq() {
	return groq`*[_type == 'page.faq'][0]{
    _type,
    "type": _type,
    "metadata": metadata{...${metadata()}},
    "footer": {...${footer()}},
    "sections": sections[]{
      _type,
      _type == 'header' => {${header}},
      _type == 'faqItems' => {${faqItems}}
    }
  }`
}
